<template>
  <div class="warehouseBillDetail">
    <van-form label-width="120px">
      <div class="warehouseBillDetail-title" v-if="pageType == 'add'">
        {{ $t.warehouse.outbound }}
      </div>
      <div class="warehouseBillDetail-title" v-if="pageType == 'detail'">
        {{ $t.warehouse.sheet6 }}
      </div>
      <div class="warehouseBillDetail-title" v-if="pageType == 'wd' || pageType == 'os'">
        {{ $t.warehouse.sheet7 }}
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1">
          <template #title>
            <div class="collapse-title">{{ $t.warehouse.warehouseInfo }}</div>
          </template>
          <van-field
            v-model="contents.WarehouseWorkNumber"
            :label="$t.warehouse.warehouseWorkOrderNumber"
            readonly
          />

          <van-field
            v-model="contents.WarehouseName"
            :label="$t.warehouse.warehouseStorageName"
            readonly
          />

          <van-field
            v-model="contents.WarehouseCode"
            :label="$t.warehouse.warehouseCode"
            readonly
          />

          <van-field
            :value="(contents.StorageTime ? contents.StorageTime : 0) + ' ' + $t.meta.day"
            :label="$t.warehouse.storageTime"
            readonly
          />

          <van-field
            v-model="contents.OutboundNumber"
            :label="$t.warehouse.outboundNumber"
            readonly
            v-if="pageType == 'wd' || pageType == 'os'"
          />
          <van-field
            v-model="contents.WarehouseNumber"
            :label="$t.warehouse.warehouseNumber"
            readonly
            v-else
          />

          <van-field
            v-model="contents.WarehousingTime"
            :label="$t.warehouse.InStorageTime"
            readonly
          />

          <van-field
            v-model="contents.OutboundTime"
            :label="$t.warehouse.outBoundTime"
            readonly
            v-if="pageType == 'wd' || pageType == 'os'"
          />

          <van-field
            v-model="contents.AppointmentStorageTime"
            :label="$t.warehouse.warehousingTime"
            readonly
            v-if="pageType == 'add' || pageType == 'detail'"
          />
        </van-collapse-item>
      </van-collapse>

      <van-collapse v-model="activeNames">
        <van-collapse-item name="2">
          <template #title>
            <div class="collapse-title" v-if="pageType == 'wd' || pageType == 'os'">
              {{ $t.warehouse.entrustEnterpriseOB }}
            </div>
            <div class="collapse-title" v-else>
              {{ $t.warehouse.entrustEnterprise }}
            </div>
          </template>

          <van-field
            v-model="contents.CustomerNumber"
            :label="$t.warehouse.customerNumber"
            readonly
          />

          <van-field
            v-model="contents.CustomerCompanyName"
            :label="$t.warehouse.enterprise"
            type="textarea"
            rows="3"
            readonly
          />

          <van-field
            v-model="contents.BusinessContact"
            :label="$t.warehouse.bContact"
            readonly
          />

          <van-field
            v-model="contents.BusinessContactPhone"
            :label="$t.warehouse.bPhone"
            readonly
          />

          <van-field
            v-model="contents.ProductsName"
            :label="$t.warehouse.productsName"
            readonly
          />
        </van-collapse-item>
      </van-collapse>

      <van-collapse
        v-model="activeNames"
        v-if="pageType == 'add' || pageType == 'detail'"
      >
        <van-collapse-item name="3">
          <template #title>
            <div class="collapse-title">{{ $t.warehouse.warehouseData }}</div>
          </template>

          <van-field
            :value="contents.ActualDeliveryQuantity + ' ' + contents.NumberUnit"
            :label="$t.warehouse.pNumber"
            readonly
          />

          <van-field
            :value="contents.IncomingVolume + ' ' + $t.warehouse.meter"
            :label="$t.warehouse.volume"
            readonly
          />

          <van-field
            :value="contents.IncomingWeight + ' ' + $t.warehouse.kilo"
            :label="$t.warehouse.weight"
            readonly
          />
        </van-collapse-item>
      </van-collapse>

      <van-collapse
        v-model="activeNames"
        v-if="pageType == 'add' || pageType == 'detail'"
      >
        <van-collapse-item name="4">
          <template #title>
            <div class="collapse-title">{{ $t.warehouse.existingData }}</div>
          </template>

          <van-field
            :value="
              contents.ExistingPiecesNumber + ' ' + contents.ExistingPiecesNumberUnit
            "
            :label="$t.warehouse.pNumber"
            readonly
          />

          <van-field
            :value="contents.ExistingPiecesVolume + ' ' + $t.warehouse.meter"
            :label="$t.warehouse.volume"
            readonly
          />

          <van-field
            :value="contents.ExistingPiecesWeight + ' ' + $t.warehouse.kilo"
            :label="$t.warehouse.weight"
            readonly
          />
        </van-collapse-item>
      </van-collapse>

      <van-collapse
        v-model="activeNames"
        v-if="pageType == 'add' || pageType == 'detail'"
      >
        <van-collapse-item name="5">
          <template #title>
            <div class="collapse-title">{{ $t.warehouse.warehouseDetail }}</div>
          </template>

          <div class="warehouseBillDetail-checkboxs">
            <div class="checkbox-label">{{ $t.warehouse.warehouseType }}</div>
            <van-checkbox-group
              v-model="form.WarehouseTypeList"
              direction="horizontal"
              disabled
            >
              <van-checkbox
                v-for="(item, index) in warehouseOptions"
                :key="index"
                :name="item.WTId"
                >{{ item.TypeName }}</van-checkbox
              >
            </van-checkbox-group>
          </div>
        </van-collapse-item>
      </van-collapse>

      <van-collapse v-model="activeNames" v-if="pageType == 'wd' || pageType == 'os'">
        <van-collapse-item name="6">
          <template #title>
            <div class="collapse-title">{{ $t.warehouse.warehouseDetail }}</div>
          </template>

          <van-steps
            direction="vertical"
            active-color="#38f"
            style="padding-bottom: 20px"
            :active="cargoHandling"
            v-if="cargoLogList && cargoLogList.length > 0"
          >
            <van-step v-for="(log, index) in cargoLogList" :key="index">
              <h3>{{ log.OperationInstructionsStr }}</h3>
              <div style="margin-bottom: 5px">{{ log.OperationTypeStr }}</div>
              <div style="margin-bottom: 5px">{{ log.OperationNumber }}</div>
              <div>{{ log.CreateTime }}</div>
            </van-step>
          </van-steps>
          <div class="collapse-button">
            <van-button size="small" type="info" @click="gotoWarehouseOperationLogList">{{
              $t.warehouse.logBtn
            }}</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>

      <div v-if="pageType == 'add'">
        <div class="warehouseBillDetail-radio">
          <div class="radio-label">{{ $t.warehouse.warehousingType }}</div>
          <van-radio-group v-model="form.WarehousingType" direction="horizontal">
            <van-radio :name="1">{{ $t.warehouse.option1 }}</van-radio>
            <van-radio :name="2">{{ $t.warehouse.option2 }}</van-radio>
          </van-radio-group>
        </div>

        <div class="custom-date">
          <div class="date-btn1">{{ $t.warehouse.outBoundTime }}</div>
          <div class="date-btn2" @click="showTimeDate">
            <span v-if="form.OutboundTime" class="value">{{ form.OutboundTime }}</span>
            <span v-else class="placeholder">{{ $t.meta.select }}</span>
          </div>
        </div>

        <div class="warehouseBillDetail-checkbox">
          <van-checkbox style="margin: 0" v-model="form.IsOnePieceForShipping">{{
            $t.warehouse.onePiece
          }}</van-checkbox>
        </div>
      </div>

      <div v-if="pageType == 'wd' || pageType == 'os'">
        <div class="warehouseBillDetail-checkbox">
          <van-checkbox style="margin: 0" v-model="contents.IsCargoTransfer" disabled>{{
            $t.warehouse.option1
          }}</van-checkbox>
        </div>

        <div class="warehouseBillDetail-checkbox">
          <van-checkbox style="margin: 0" v-model="contents.IsCargoOutbound" disabled>{{
            $t.warehouse.option2
          }}</van-checkbox>
        </div>

        <div class="warehouseBillDetail-checkbox">
          <van-checkbox
            style="margin: 0"
            v-model="contents.IsOnePieceForShipping"
            disabled
            >{{ $t.warehouse.onePiece }}</van-checkbox
          >
        </div>
      </div>

      <div class="multi-table" v-if="form.DetailList && form.DetailList.length > 0">
        <div class="warehouseBillDetail-title">
          <div class="title-left" v-if="pageType == 'add'">
            {{ $t.warehouse.selectCargo }}
          </div>
          <div class="title-left" v-else>
            {{ $t.warehouse.goodsExistDetail }}
          </div>
          <div class="title-right" v-if="pageType == 'add'">
            <van-checkbox
              v-model="form.IsSelectAll"
              @click="handledSelectAll(form.IsSelectAll)"
              :disabled="form.IsOnePieceForShipping == 1 ? true : false"
              class="multi-table-selectAll"
              >{{ $t.warehouse.selectAll }}</van-checkbox
            >
          </div>
        </div>
        <div
          class="multi-table-box"
          v-for="(item, index) in form.DetailList"
          :key="index"
        >
          <div class="multi-table-count" v-if="pageType == 'add'">No.{{ index + 1 }}</div>
          <div v-if="item.ProductList && item.ProductList.length > 0">
            <van-checkbox
              v-if="pageType == 'add'"
              v-model="item.Checked"
              :disabled="form.IsOnePieceForShipping == 1 ? true : false"
              @click="handleSelectionChange(item.Checked, index)"
              class="multi-table-selectBox"
            ></van-checkbox>
            <div class="multi-table-header">
              <div class="multi-table-title">
                {{ $t.warehouse.caseNumberSn }}：{{ item.BoxName }}
              </div>
              <div class="multi-table-title">
                {{ $t.warehouse.parentBoxName }}：{{ item.ParentBoxName }}
              </div>
              <div class="multi-table-title">
                {{ $t.warehouse.size }}：{{ item.Size }}
              </div>
              <div class="multi-table-title">
                {{ $t.warehouse.volume }}：{{ item.Cubicmeter }}
              </div>
              <div class="multi-table-title">
                {{ $t.warehouse.weight }}：{{ item.Weight }}
              </div>
              <div class="multi-table-title">
                {{ $t.warehouse.dayOfStorage }}：{{ item.StorageDays }}
              </div>
              <div class="multi-table-title">
                {{ $t.warehouse.remark }}：{{ item.Remark }}
              </div>
            </div>
            <div v-for="(product, idx) in item.ProductList" :key="idx">
              <van-card
                style="background-color: transparent"
                :num="
                  pageType == 'detail'
                    ? product.StockQuantity + ' ' + $t.warehouse.inventory
                    : product.OutboundQuantity + ' ' + $t.warehouse.exportNumber
                "
                :price="' ' + $t.warehouse.goodsValue + ': ' + product.GoodsValue"
                :desc="' ' + $t.warehouse.remark + ': ' + product.Remark"
                :title="product.ProductName"
                :thumb="
                  product.ProductPictures
                    ? imgUrlFilter(product.ProductPictures)
                    : cargoImg
                "
                currency=""
                @click-thumb="
                  product.ProductPictures
                    ? imagePreview(imgUrlFilter(product.ProductPictures))
                    : false
                "
              >
                <template #tags>
                  <span style="font-size: 12px; margin-right: 10px" v-if="product.Brand"
                    >{{ $t.warehouse.brand }} : {{ product.Brand }}</span
                  >
                  <span style="font-size: 12px" v-if="product.Model"
                    >{{ $t.warehouse.model }} : {{ product.Model }}</span
                  >
                  <div
                    style="font-size: 12px; color: #4ab7bd; margin: 3px 0px 3px 0px"
                    v-if="pageType == 'add'"
                  >
                    {{ $t.warehouse.inventory }} : {{ product.StockQuantity }}
                  </div>
                </template>
                <template #footer>
                  <van-button
                    size="small"
                    type="info"
                    v-if="pageType == 'detail'"
                    class="multi-table-updateName"
                    @click="dialogNameShow(product)"
                    >{{ $t.warehouse.updateName }}</van-button
                  >
                  <van-button
                    size="small"
                    type="info"
                    v-if="pageType == 'detail'"
                    class="multi-table-updateImage"
                    @click="dialogImageShow(product)"
                    >{{ $t.warehouse.updateImage }}</van-button
                  >
                  <van-checkbox
                    v-model="product.Checked"
                    v-if="form.IsOnePieceForShipping == 1"
                    @click="handleProductChange"
                    class="multi-table-selectProduct"
                  ></van-checkbox>
                </template>
              </van-card>

              <van-field
                :label="$t.warehouse.exportNumber"
                required
                v-if="pageType == 'add'"
              >
                <template #input>
                  <van-stepper
                    v-model="product.OutboundQuantity"
                    @change="handleProductChange"
                    input-width="40px"
                    button-size="32px"
                    :min="0"
                    :max="product.StockQuantity"
                    :default-value="0"
                    :disabled="form.IsOnePieceForShipping == 1 ? false : true"
                  />
                </template>
              </van-field>
            </div>
          </div>
          <div class="multi-table-box-empty" v-else>{{ $t.meta.noData }}</div>
        </div>
      </div>

      <div v-if="pageType == 'add'">
        <div class="warehouseBillDetail-title">{{ $t.warehouse.total }}</div>
        <div v-if="form.IsOnePieceForShipping">
          <van-field
            v-model="onePieceTotal"
            :label="$t.warehouse.productTotal"
            readonly
          />
          <van-field v-model="onePieceQty" :label="$t.warehouse.outboundTotal" readonly />
        </div>
        <div v-else>
          <van-field v-model="products.length" :label="$t.warehouse.boxTotal" readonly />
          <van-field v-model="productsQty" :label="$t.warehouse.outboundTotal" readonly />
        </div>
        <div class="warehouseBillDetail-title">
          {{ $t.warehouse.pickupPerson }}
        </div>
        <van-field
          v-model="form.LicensePlateNumber"
          :label="$t.warehouse.plate"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.ContactPerson"
          :label="$t.warehouse.driverName"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.ContactPhone"
          :label="$t.warehouse.driverPhone"
          :placeholder="$t.meta.input"
        />
        <div class="warehouseBillDetail-title">
          {{ $t.warehouse.expressTitle }}
        </div>
        <van-field
          v-model="form.ExpressCompanyName"
          :label="$t.warehouse.expressCompany"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.ExpressNumber"
          :label="$t.warehouse.expressNumber"
          :placeholder="$t.meta.input"
        />
        <div class="warehouseBillDetail-title">{{ $t.warehouse.others }}</div>
        <van-field
          v-model="form.Remark"
          :label="$t.warehouse.remark"
          :placeholder="$t.meta.input"
          type="textarea"
        />
      </div>
      <div v-if="pageType == 'detail'">
        <div class="warehouseBillDetail-title">
          <div class="title-left">{{ $t.warehouse.driverInfo }}</div>
          <div class="title-right">
            <van-button size="small" type="info" @click="plateSubmit">{{
              $t.meta.save
            }}</van-button>
          </div>
        </div>
        <van-field
          v-model="plateForm.DeliveryLicensePlateNumber"
          :label="$t.warehouse.driverPlate"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="plateForm.EmergencyContactPerson"
          :label="$t.warehouse.driverName"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="plateForm.EmergencyContactPhone"
          :label="$t.warehouse.driverPhone"
          :placeholder="$t.meta.input"
        />
        <div class="warehouseBillDetail-title">
          <div class="title-left">{{ $t.warehouse.expressTitle }}</div>
          <div class="title-right">
            <van-button size="small" type="info" @click="expressSubmit">{{
              $t.meta.save
            }}</van-button>
          </div>
        </div>
        <van-field
          v-model="expressForm.ExpressCompanyName"
          :label="$t.warehouse.expressCompany"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="expressForm.ExpressNumber"
          :label="$t.warehouse.expressNumber"
          :placeholder="$t.meta.input"
        />
      </div>
      <div v-if="pageType == 'wd' || pageType == 'os'">
        <div class="warehouseBillDetail-title">
          {{ $t.warehouse.pickupPerson }}
        </div>
        <van-field
          v-model="contents.LicensePlateNumber"
          :label="$t.warehouse.driverPlate"
          readonly
        />
        <van-field
          v-model="contents.ContactPerson"
          :label="$t.warehouse.driverName"
          readonly
        />
        <van-field
          v-model="contents.ContactPhone"
          :label="$t.warehouse.driverPhone"
          readonly
        />
        <van-field
          v-model="contents.ExpressCompanyName"
          :label="$t.warehouse.expressCompany"
          readonly
        />
        <van-field
          v-model="contents.ExpressNumber"
          :label="$t.warehouse.expressNumber"
          readonly
        />
        <van-field
          v-model="contents.OutboundTime"
          :label="$t.warehouse.outBoundTime"
          readonly
        />
        <van-field
          v-model="contents.Remark"
          :label="$t.warehouse.remark"
          type="textarea"
          rows="5"
          readonly
        />
      </div>

      <div style="margin: 16px" v-if="pageType == 'add'">
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-dialog
      :title="$t.warehouse.dialog8"
      width="90%"
      v-model="dialogNameVisible"
      @confirm="dialogNameSubmit"
      @cancel="dialogNameClose"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="warehouseBillDetail-alert">
          <van-form label-width="120px">
            <van-field
              v-model="nameForm.ProductName"
              :label="$t.warehouse.productsNameSn"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.warehouse.dialog9"
      width="90%"
      v-model="dialogImageVisible"
      @confirm="dialogImageSubmit"
      @cancel="dialogImageClose"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="warehouseBillDetail-alert">
          <van-form label-width="120px">
            <van-field :label="$t.warehouse.productImage" required>
              <template #input>
                <van-uploader
                  v-model="imageDisplay"
                  :max-count="1"
                  :after-read="afterRead1"
                />
              </template>
            </van-field>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="datetime"
        :title="$t.warehouse.outBoundTime"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar" v-if="pageType == 'wd' || pageType == 'os'">
      <van-button type="info" block @click="gotoPrint">{{
        $t.warehouse.printBtn
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Uploader,
  Stepper,
  Collapse,
  CollapseItem,
  Card,
  Step,
  Steps,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper)
  .use(Collapse)
  .use(CollapseItem)
  .use(Card)
  .use(Step)
  .use(Steps);

export default {
  name: "warehouseBillDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      cargoImg: require("@/assets/img/warehouseManagement/cargo.png"),
      pageType: "",
      WGId: "",
      WOId: "",
      contents: {},
      activeNames: [],
      form: {
        WarehouseTypeList: [],
        WarehousingType: null,
        IsSelectAll: 0,
        IsOnePieceForShipping: 0,
        LicensePlateNumber: "",
        ContactPerson: "",
        ContactPhone: "",
        ExpressCompanyName: "",
        ExpressNumber: "",
        OutboundTime: "",
        DetailList: [],
        WorkOrderList: [],
        Remark: "",
      },
      warehouseOptions: [],
      cargoLogList: [],
      cargoHandling: 0,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
      //出仓货物
      products: [],
      productsQty: 0,
      onePieceTotal: 0,
      onePieceQty: 0,
      //司机资料
      plateForm: {
        WHAFId: "",
        DeliveryLicensePlateNumber: "",
        EmergencyContactPerson: "",
        EmergencyContactPhone: "",
      },
      //快递资料
      expressForm: {
        WHAFId: "",
        ExpressCompanyName: "",
        ExpressNumber: "",
      },
      //修改产品名称
      dialogNameVisible: false,
      nameForm: {
        PId: 0,
        ProductName: "",
      },
      //修改产品图片
      dialogImageVisible: false,
      imageDisplay: [],
      imageForm: {
        PId: 0,
        ProductPictures: "",
      },
    };
  },
  created() {
    const { Type, WGId, WOId } = this.$route.query;
    if (Type) {
      this.pageType = Type;
      if (this.pageType == "wd" || this.pageType == "os") {
        this.WOId = WOId;
        this.getWarehouseOutboundWorkOrderDetail();
      } else {
        this.WGId = WGId;
        this.getWarehouseWorkOrderDetail().then((success) => {
          if (success) {
            this.initOutboundNumber();
          }
        });
      }
    }
  },
  methods: {
    gotoWarehouseOperationLogList() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "warehouseOperationLogList",
        name: "warehouseOperationLogList",
        query: [
          {
            name: "WarehouseWorkNumber",
            value: this.contents.WarehouseWorkNumber,
          },
        ],
      });
    },
    gotoPrint() {
      var param = {
        WOId: this.WOId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createWarehouseOutboundWorkOrderFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    dialogImageClose() {
      this.imageForm.PId = 0;
      this.imageForm.ProductPictures = "";
      this.imageDisplay = [];
      this.dialogImageVisible = false;
    },
    dialogImageSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        ...this.imageForm,
      };
      this.$api.storage
        .editProductPicturesByPId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogImageClose();
          this.getWarehouseWorkOrderDetail();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogImageShow(product) {
      this.imageForm.PId = product.PId;
      this.imageForm.ProductPictures = product.ProductPictures;
      if (product.ProductPictures) {
        this.imageDisplay.push({
          url: this.imgUrlFilter(product.ProductPictures),
        });
      }
      this.dialogImageVisible = true;
    },
    dialogNameClose() {
      this.nameForm.PId = 0;
      this.nameForm.ProductName = "";
      this.dialogNameVisible = false;
    },
    dialogNameSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        ...this.nameForm,
      };
      this.$api.storage
        .editWorkOrderProductName(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogNameClose();
          this.getWarehouseWorkOrderDetail();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogNameShow(product) {
      this.nameForm.PId = product.PId;
      this.nameForm.ProductName = product.ProductName;
      this.dialogNameVisible = true;
    },
    plateSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        ...this.plateForm,
      };
      this.$api.storage
        .editWarehousingApplyForDeliveryInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    expressSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        ...this.expressForm,
      };
      this.$api.storage
        .editWarehousingApplyForExpressInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    calculateQty() {
      let vue = this;
      vue.$forceUpdate();
      var sum = 0;
      for (const product of this.products) {
        sum =
          sum +
          product.ProductList.reduce(
            (accumulator, cur) => accumulator + parseInt(cur.StockQuantity),
            0
          );
      }
      this.productsQty = sum;
    },
    handledSelectAll(IsSelectAll) {
      let vue = this;
      vue.$forceUpdate();
      for (var index in this.form.DetailList) {
        if (IsSelectAll) {
          this.form.DetailList[index].Checked = true;
          this.products.push(this.form.DetailList[index]);
        } else {
          this.form.DetailList[index].Checked = false;
          this.products = [];
        }
      }
      this.calculateQty();
    },
    handleSelectionChange(checked, index) {
      let vue = this;
      vue.$forceUpdate();
      if (checked) {
        if (this.products.find((p) => p.BoxName == this.form.DetailList[index].BoxName)) {
        } else {
          this.products.push(this.form.DetailList[index]);
        }
      } else {
        var dIdx = this.products.findIndex(
          (p) => p.PLId == this.form.DetailList[index].PLId
        );
        this.products.splice(dIdx, 1);
      }
      if (this.products.length == this.form.DetailList.length) {
        this.form.IsSelectAll = true;
      } else {
        this.form.IsSelectAll = false;
      }
      this.calculateQty();
    },
    handleProductChange() {
      let vue = this;
      vue.$forceUpdate();
      var total = 0;
      var sum = 0;
      for (const detail of this.form.DetailList) {
        var products = detail.ProductList.filter((item) => {
          return item.Checked == true;
        });
        total = total + products.length;
        if (products.length > 0) {
          var count = products.reduce(
            (accumulator, cur) => accumulator + cur.OutboundQuantity,
            0
          );
          if (count > 0) {
            sum = sum + parseInt(count);
          }
        }
      }
      this.onePieceTotal = total;
      this.onePieceQty = sum;
    },
    initOutboundNumber() {
      if (this.contents.PackingList && this.contents.PackingList.length > 0) {
        var detailList = this.contents.PackingList;
        for (const detail of detailList) {
          detail.Checked = false;
          for (const product of detail.ProductList) {
            if (product.StockQuantity) {
              product.OutboundQuantity = 0;
            }
          }
        }
        this.form.DetailList = detailList;
      }
    },
    showTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        var hour = value.getHours() < 10 ? "0" + value.getHours() : value.getHours();
        var minute =
          value.getMinutes() < 10 ? "0" + value.getMinutes() : value.getMinutes();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute;
      };
      this.form.OutboundTime = formatDate(date);
      this.showTimePicker = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    applyInfo(data) {
      this.plateForm.WHAFId = data.WHAFId;
      this.plateForm.EmergencyContactPerson = data.EmergencyContactPerson;
      this.plateForm.EmergencyContactPhone = data.EmergencyContactPhone;
      this.plateForm.DeliveryLicensePlateNumber = data.DeliveryLicensePlateNumber;
      this.expressForm.WHAFId = data.WHAFId;
      this.expressForm.ExpressCompanyName = data.ExpressCompanyName;
      this.expressForm.ExpressNumber = data.ExpressNumber;
    },
    getWarehouseWorkOrderDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WGId: this.WGId,
        };
        this.$api.storage
          .getWarehouseWorkOrderDetail(param)
          .then((res) => {
            this.contents = res.data;
            this.applyInfo(res.data);
            this.warehouseOptions = this.contents.WarehouseTypeList;
            this.form.DetailList = this.contents.PackingList;
            this.form.Remark = this.contents.Remark;
            for (const option of this.warehouseOptions) {
              if (option.IsChecked == 1) {
                this.form.WarehouseTypeList.push(option.WTId);
              }
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getWarehouseOutboundWorkOrderDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WOId: this.WOId,
        };
        this.$api.storage
          .getWarehouseOutboundWorkOrderDetail(param)
          .then((res) => {
            this.contents = res.data;
            this.form.DetailList = this.contents.PackingList;
            this.form.Remark = this.contents.Remark;
            this.cargoLogList = this.contents.CargoLogList;
            this.cargoHandling = this.contents.CargoHandling;
            this.activeNames = ["6"];
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      var detailList = [];
      var pushItem = (product) => {
        var items = this.form.DetailList;
        detailList.push({
          PLId: product.PLId,
          BoxName: items.find((d) => d.PLId == product.PLId).BoxName,
          PId: product.PId,
          ProductsName: product.ProductName,
          OutboundQuantity: this.form.IsOnePieceForShipping
            ? product.OutboundQuantity
            : product.StockQuantity,
        });
      };
      if (this.form.IsOnePieceForShipping) {
        for (const detail of this.form.DetailList) {
          for (const product of detail.ProductList) {
            if (product.Checked) {
              pushItem(product);
            }
          }
        }
      } else {
        for (const detail of this.form.DetailList) {
          if (detail.Checked) {
            for (const product of detail.ProductList) {
              pushItem(product);
            }
          }
        }
      }
      var param = {
        WGId: this.WGId,
        CargoHandling: this.form.WarehousingType,
        IsOnePieceForShipping: this.form.IsOnePieceForShipping,
        ContactPerson: this.form.ContactPerson,
        ContactPhone: this.form.ContactPhone,
        LicensePlateNumber: this.form.LicensePlateNumber,
        ExpressCompanyName: this.form.ExpressCompanyName,
        ExpressNumber: this.form.ExpressNumber,
        OutboundTime: this.form.OutboundTime,
        Remark: this.form.Remark,
      };
      param.DetailList = detailList;
      this.$commonMethod.showLoading();
      this.$api.storage
        .addWarehouseOutbound(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.imageForm.ProductPictures = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.warehouseBillDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-steps {
    background: transparent;
  }
  .collapse-title {
    color: #646566;
  }
  .collapse-button {
    width: 100%;
    text-align: right;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0px 15px 15px 15px;
    background: transparent;
    border-top: 1px solid #ebedf0;
  }
  ::v-deep .van-collapse {
    border-bottom: 1px solid #ebedf0;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
  .warehouseBillDetail-title {
    font-size: 14px;
    padding: 15px;
    color: #1890ff;
    background: #f1f1f1;
    .title-left {
      width: 80%;
      display: inline-block;
      vertical-align: middle;
      color: #1890ff;
    }
    .title-right {
      width: 20%;
      display: inline-block;
      vertical-align: middle;
      text-align: right;
      color: #999;
      .multi-table-selectAll {
        position: static;
      }
    }
  }
  .warehouseBillDetail-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .warehouseBillDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
  .warehouseBillDetail-checkboxs {
    padding-top: 15px;
    ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
      i {
        color: #1890ff;
        font-weight: bold;
      }
    }
    ::v-deep .van-checkbox__label {
      color: #646566 !important;
    }
    .checkbox-label {
      color: #646566;
      margin-bottom: 10px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .warehouseBillDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
      i {
        color: #1890ff;
        font-weight: bold;
      }
    }
    ::v-deep .van-checkbox__label {
      margin-left: 8px;
      color: #646566 !important;
    }
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 15px 20px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 33%;
      display: inline-block;
      margin-right: 5%;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 62%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .multi-table {
    .multi-table-count {
      padding-top: 10px;
      padding-left: 10px;
      font-size: 12px;
      color: #999;
    }
    .multi-table-box {
      width: 100%;
      .multi-table-selectBox {
        margin: 15px 15px 0px 15px;
      }
      .multi-table-updateName {
        margin: 10px;
        ::v-deep .van-button__text {
          font-size: 14px !important;
        }
      }
      .multi-table-updateImage {
        margin: 10px 0px;
        ::v-deep .van-button__text {
          font-size: 14px !important;
        }
      }
      .multi-table-selectProduct {
        display: inline-block;
        padding: 23px 15px 10px 15px;
      }
      .multi-table-header {
        padding: 10px 15px 10px 15px;
        border-bottom: 1px solid #ebedf0;
        .multi-table-title {
          font-size: 12px;
          color: #646566;
          width: 100%;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
    .multi-table-box-empty {
      text-align: center;
      padding: 30px;
      font-size: 14px;
      color: #969799;
      border-bottom: 1px solid #ebedf0;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
